import script from "./DocExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocExport.vue?vue&type=script&setup=true&lang=ts"

import "./DocExport.vue?vue&type=style&index=0&id=7e63f462&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e63f462"]])

export default __exports__